import React from 'react'
import st from './AverageStatistic.module.scss'
import { formatDuration } from '../CallAnalytics'

const AverageStatistic = ({
  averageIncomingCalls,
  averageOutgoingCalls,
  averageTotalCalls,
  averageIncomingDuration,
  averageOutgoingDuration,
  averageTotalDuration,
  sortBy,
  translate,
}) => {
  return (
    <div className={st.statistic}>
      <div className={st.statisticHeader}>
        <h3>{translate?.average}</h3>
      </div>
      <div className={st.statisticType}>
        <div>{translate?.incoming}</div>
        <div className={st.verticalSeparator}></div>
        <div>{translate?.outgoing}</div>
      </div>
      <div className={st.callInfo}>
        <div className={st.progressBarAndTotal}>
          <div className={st.progressBar}>
            <div
              className={st.incomingBar}
              style={{
                width: `${(averageIncomingCalls / averageTotalCalls) * 100}%`,
              }}
            >
              {sortBy === 'quantity'
                ? averageIncomingCalls
                : formatDuration(averageIncomingDuration)}
            </div>
            <div
              className={st.outgoingBar}
              style={{
                width: `${(averageOutgoingCalls / averageTotalCalls) * 100}%`,
              }}
            >
              {sortBy === 'quantity'
                ? averageOutgoingCalls
                : formatDuration(averageOutgoingDuration)}
            </div>
          </div>
          <div className={st.totalCalls}>
            {sortBy === 'quantity'
              ? averageTotalCalls
              : formatDuration(averageTotalDuration)}
          </div>
        </div>
      </div>
    </div>
  )
}

export default AverageStatistic
